<template>
  <div class="cooperation_application">
    <div class="s_wrapper">
      <el-input class="s_input" v-model="titleName" suffix-icon="el-icon-search" placeholder="搜索标题名称" clearable @change="onSearch"></el-input>
      <el-button type="primary" @click="handladd(0)">新增</el-button>
    </div>
    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540">
        <el-table-column label="序号" show-overflow-tooltip width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="title" label="标题"></el-table-column>
        <el-table-column show-overflow-tooltip prop="content" label="内容"></el-table-column>
        <el-table-column show-overflow-tooltip prop="contentUrl" label="图片">
          <template slot-scope="scope">
            <el-image style="width: 60px; height: 60px" fit="cover" :src="scope.row.contentUrl" @click="previewImage(scope.row.contentUrl)"></el-image>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="linkUrl" label="链接"></el-table-column>
        <el-table-column show-overflow-tooltip prop="sortNum" label="排序"></el-table-column>
        <el-table-column show-overflow-tooltip label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row)">修改</el-button>
            <el-button type="danger" plain @click="handleDel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>

    <el-dialog :title="add == 0 ? '新增' : '编辑'" :visible.sync="dialogVisible" :before-close="onCancel">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" class="ruleForm">
        <div style="display: flex">
          <el-form-item label="标题" prop="title">
            <el-input v-model="ruleForm.title" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="显示顺序" prop="sortNum">
            <el-input v-model.number="ruleForm.sortNum" placeholder="请输入"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="图片上传" prop="contentUrl">
          <el-upload ref="upload" class="upload-demo" accept=".png,.jpeg,.jpg" :file-list="fileList" :limit="1" name="multipartFile" :headers="headers" :action="action" :on-success="busiLicenseSuccess" :before-upload="beforeUploads" :on-remove="handleRemove" :on-exceed="onExceed" list-type="picture">
            <el-button type="primary">点击上传</el-button>
            <div slot="tip" class="el_upload__tip">
              <i class="el-icon-warning"></i>
              <span>请确保项目图片信息清晰可见，图片格式仅支持jpg、jpeg、png，图片大小不超过5MB。</span>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="链接" prop="linkUrl">
          <el-input v-model="ruleForm.linkUrl" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input type="textarea" placeholder="请输入" :autosize="{ minRows: 5, maxRows: 10 }" v-model="ruleForm.content" maxlength="200" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
    <el-image-viewer
      v-if="showViewer"
      :on-close="
        () => {
          showViewer = false
        }
      "
      :url-list="imgList"
    ></el-image-viewer>
  </div>
</template>

<script>
export default {
  components: {
    "el-image-viewer": () => import("element-ui/packages/image/src/image-viewer"),
  },
  data() {
    return {
      // 图片预览
      showViewer: false,
      imgList: [],
      add: 0,
      headers: { token: this.$store.state.token },
      action: this.$axios.defaults.baseURL + this.$api.uploadFile,
      fileList: [],
      dialogVisible: false,
      tableData: [],
      titleName: "",
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
      ruleForm: {
        title: "", //标题
        linkUrl: "", //链接
        content: "", //内容
        sortNum: "", //排序
        contentUrl: "", //图片
        contentType: 1, //图片
        bizType: 1, //类型
      },
      rules: {
        title: [{ required: true, message: "缺少标题", trigger: "blur" }],
        contentUrl: [{ required: true, message: "缺少图片", trigger: "blur" }],
        linkUrl: [{ required: true, message: "缺少链接", trigger: "blur" }],
        sortNum: [
          { required: true, message: "缺少排序", trigger: "blur" },
          {
            validator: function (rule, value, callback) {
              if (/^[0-9]*$/.test(value) == false) {
                callback(new Error("请输入数字"))
              } else {
                //校验通过
                callback()
              }
            },
            trigger: "blur",
          },
        ],
      },
    }
  },
  created() {
    this.selectNoticeInfoAllList()
  },
  methods: {
    // 图片放大
    previewImage(url) {
      this.imgList[0] = url
      this.showViewer = true
    }, // 时间搜索
    onSearch(value) {
      this.titleName = value
      this.clearData()
      this.selectNoticeInfoAllList()
    },
    // 删除
    handleDel(row) {
      this.$confirm("是否确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        this.$axios
          .post(this.$api.bannerDelete, {
            id: row.id,
            bizType: row.bizType,
          })
          .then(res => {
            this.selectNoticeInfoAllList()
            this.$message({
              message: res.desc,
              type: "success",
            })
          })
          .catch(err => {
            this.$message({
              message: err.desc,
              type: "error",
            })
          })
      })
    },
    // 新增
    handladd(index) {
      this.add = index
      this.dialogVisible = true
    },
    // 编辑
    handleEdit(row, index) {
      this.add = index
      let data = Object.assign({}, row)
      this.ruleForm.title = data.title
      this.ruleForm.linkUrl = data.linkUrl
      this.ruleForm.bizType = data.bizType
      this.ruleForm.contentType = data.contentType
      this.ruleForm.contentUrl = data.contentUrl
      this.ruleForm.content = data.content
      this.ruleForm.sortNum = data.sortNum
      this.ruleForm.id = data.id
      this.fileList = [{ url: data.contentUrl, name: data.contentUrl }]
      this.dialogVisible = true
    },
    // 发布
    submitForm(ruleForm) {
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          if (this.add == 0) {
            this.ruleForm.contentType = 1
            this.ruleForm.bizType = 1
            console.log(this.ruleForm)
            this.$axios
              .post(this.$api.bannerSave, this.ruleForm)
              .then(res => {
                this.selectNoticeInfoAllList()
                this.onCancel()
                this.$message({
                  message: res.desc,
                  type: "success",
                })
              })
              .catch(err => {
                this.$message({
                  message: err.desc,
                  type: "error",
                })
              })
          } else {
            this.$axios
              .post(this.$api.bannerUpdate, {
                title: this.ruleForm.title,
                linkUrl: this.ruleForm.linkUrl,
                bizType: this.ruleForm.bizType,
                contentType: this.ruleForm.contentType,
                contentUrl: this.ruleForm.contentUrl,
                content: this.ruleForm.content,
                sortNum: this.ruleForm.sortNum,
                id: this.ruleForm.id,
              })
              .then(res => {
                this.selectNoticeInfoAllList()
                this.onCancel()
                this.$message({
                  message: res.desc,
                  type: "success",
                })
              })
              .catch(err => {
                this.$message({
                  message: err.desc,
                  type: "error",
                })
              })
          }
        } else {
          return false
        }
      })
    },
    onCancel() {
      this.dialogVisible = false
      this.ruleForm = {}
      this.$refs.upload.clearFiles()
    },
    // 清空
    clearData() {
      this.tableData = []
      this.currentPage = 1
    },
    // 删除营业执照
    handleRemove() {
      this.$refs.upload.clearFiles()
    },
    onExceed() {
      this.$message.error("最多只能上传一张图片，请删除后重新上传")
    },
    // 项目图片上传成功
    busiLicenseSuccess(res) {
      if (res.code == 100) {
        // this.ruleForm.picId = res.result.fileId;
        this.ruleForm.contentUrl = res.result.fileUrl
      } else {
        this.$message({ showClose: true, message: res.desc, type: "error" })
      }
    },
    // 文件上传
    beforeUploads(file) {
      const isJPG = file.type === "image/jpeg" || "image/jpg" || "image/png"
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isJPG) {
        this.$message.error("图文只支持jpg、png、jpeg，请调整格式再上传!")
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!")
      }
      return isJPG && isLt5M
    },
    // 获取列表
    selectNoticeInfoAllList() {
      let params = {
        page: this.currentPage,
        pageSize: this.pageSize,
        bizType: 1,
        titleName: this.titleName,
      }
      this.$axios
        .get(this.$api.pageList, { params })
        .then(res => {
          if (res.code == 100) {
            this.tableData = res.result.list
            this.totalItemsCount = res.result.totalCount
          }
        })
        .catch(err => {
          this.$message({
            message: err.desc,
            type: "error",
          })
        })
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.selectNoticeInfoAllList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.selectNoticeInfoAllList()
    },
  },
}
</script>

<style scoped lang="scss">
.cooperation_application {
  .el-icon-warning {
    color: #0096ff;
    font-size: 16px;
  }
  ::v-deep .el-upload-list {
    width: 30% !important;
  }
  ::v-deep .el-dialog .el-input__inner {
    // width: 320px !important;
  }
  .el-textarea {
    width: 92% !important;
  }
  ::v-deep .el-input__count {
    background: transparent !important;
  }
}
</style>
